module.exports = __webpack_public_path__ + "img/tt.95ffe73e.svg";